import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ customClass, color = 'currentColor', height = 20, width = 20 }: IconComponentProps) => <svg width={width} height={height} viewBox='1 1 22 22' class={customClass}>
  <path d='M12 1C5.9346 1 1 5.9346 1 12C1 18.0654 5.9346 23 12 23C18.0654 23 23 18.0654 23 12C23 5.9346 18.0654 1 12 1ZM9.8011 16.8543L5.7168 12.7788L7.27 11.2212L9.7989 13.7457L15.6223 7.9223L17.1777 9.4777L9.8011 16.8543V16.8543Z' fill={color} />
</svg>
